// extracted by mini-css-extract-plugin
export default {"companyContainer":"career-block_companyContainer__0MxZ+","cardsContainer":"career-block_cardsContainer__rW6Wy"};